import { useEffect, useRef, useState } from 'react';

const useCountDownTimer = (
  time: number,
  callback?: (seconds: number) => void,
): number => {
  const [seconds, setSeconds] = useState<number>(time);
  const timerId = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    clearInterval(timerId.current);

    setSeconds(time);

    if (time > 0) {
      timerId.current = setInterval(() => {
        setSeconds((state) => (state > 0 ? state - 1 : 0));
      }, 1000);
    }

    return (): void => clearInterval(timerId.current);
  }, [time]);

  useEffect(() => {
    if (seconds <= 0) {
      clearInterval(timerId.current);
    }

    if (callback) {
      callback(seconds);
    }
  }, [seconds]);

  return seconds;
};

export { useCountDownTimer };
